import { IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { SupplierTypeEnum } from '@gtpl/shared-models/common-models';

export class SupplierTypeRequest {
    @ApiProperty({
        enum: SupplierTypeEnum
    })
    @IsEnum(SupplierTypeEnum)
    supplierType: SupplierTypeEnum;
    constructor(supplierType:SupplierTypeEnum){
        this.supplierType = supplierType;
    }
}